import {h, Fragment} from "preact"
import { useAppState, useLoadMore } from "@nosto/preact"
import { defaultConfig } from "../config"

export default function LoadMore() {
    const { response: { products } } = useAppState();
    const loadedTotal = products?.size ?? 0;
    const productTotal = products?.total ?? 0;
    const { loadMore } = useLoadMore(defaultConfig.serpSize);

    return (
        <div className="ns-load-more">
            <div className="ns-load-more__label">
                You've viewed {(loadedTotal < productTotal) ? loadedTotal : productTotal} products of {productTotal}
            </div>
            {(loadedTotal < productTotal) && 
                <button
                    type="button"
                    className="ns-load-more__button"
                    aria-label="Load more products"
                    onClick={() => { loadMore() }}
                >
                    Load More
                </button>
            }
        </div>
    )
}